import memoize from 'memoizee'

export const getContactInfoForOrg = memoize((state, orgId) => {
  const { contactInfo } = state.orgContactInformation
  return contactInfo[orgId]
})
